import ButtonSelector from "../../../../src/components/docs/examples/Buttons/ButtonSelector";
import ColoringButtons from "../../../../src/components/docs/examples/Buttons/ColoringButtons";
import FullWidthButton from "../../../../src/components/docs/examples/Buttons/FullWidthButton";
import OutlinedButtons from "../../../../src/components/docs/examples/Buttons/OutlinedButtons";
import ButtonBorderRadius from "../../../../src/components/docs/examples/Buttons/ButtonBorderRadius";
import SizingButtons from "../../../../src/components/docs/examples/Buttons/SizingButtons";
import TextAndIconButtons from "../../../../src/components/docs/examples/Buttons/TextAndIconButtons";
import IconOnlyButtons from "../../../../src/components/docs/examples/Buttons/IconOnlyButtons";
import ButtonGroup from "../../../../src/components/docs/examples/Buttons/ButtonGroup";
import * as React from 'react';
export default {
  ButtonSelector,
  ColoringButtons,
  FullWidthButton,
  OutlinedButtons,
  ButtonBorderRadius,
  SizingButtons,
  TextAndIconButtons,
  IconOnlyButtons,
  ButtonGroup,
  React
};